import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery } from "@/redux/ExportPage/fetchBaseQuery";


export const jobWorkApi = createApi({
  reducerPath: "jobWorkApi",
  baseQuery,
  tagTypes: ["JoBWork"],
  endpoints: (builder) => ({
    getJobworkByMasterId: builder.query({
      query: ({id}) => `export/product/jobWork/${id}`,
      transformResponse: (response) => {
        const data = response?.data ?? [];
        const normalized = Array.isArray(data) ? data : [data];
        return normalized.map((item) => ({
          ...item,
          id: item.exportProductJobWorkId, 
        }));
      },
      providesTags: ["JoBWork"],
    }),
  
    updateJobwork: builder.mutation({
      query: ({ id, subId, ...data }) => ({
        url: `export/product/jobWork/${id}/${subId}`,
        method: "PUT",
        body: { exportProductJobWork: data },
        headers: {
          "X-Request-Id": Math.random().toString(36).substring(2),
        }, 
      }),
      invalidatesTags: ["JoBWork"],
    }),

   
    deleteJobwork: builder.mutation({
      query: ({ id }) => ({
        url: `export/product/jobWork/${id}`,
        method: "DELETE",
        headers: {
          "X-Request-Id": Math.random().toString(36).substring(2),
        },
      }),
      invalidatesTags: ["JoBWork"],
    }),

   
    createJobwork: builder.mutation({
      query: ({ id, ...data }) => ({
        url: `export/product/jobWork/${id}`,
        method: "PUT", 
        body: { exportProductJobWork: data },
        headers: {
          "X-Request-Id": Math.random().toString(36).substring(2),
        }, 
      }),
      invalidatesTags: ["JoBWork"],
    }),
  }),
});

export const {
  useLazyGetJobworkByMasterIdQuery,
  useUpdateJobworkMutation,
  useDeleteJobworkMutation, 
  useCreateJobworkMutation, 
} = jobWorkApi;

